import {Component, OnInit} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {UserServiceService} from "../../../service/user-service.service";
import {Router} from "@angular/router";
import {ErrorMessages} from "../../../model/error-messages.enum";
import {CustomValidators} from "../../../CustomValidators";

/**
 * Register functionality currently not active. Instead replaced by requesting an account by mail.
 */
@Component({
  selector: 'app-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.css']
})
export class RegisterFormComponent implements OnInit {

  userForm: UntypedFormGroup;
  toNextPage: boolean = false;
  errorMessage: string;
  showBilling : boolean = false;

  constructor(private formBuilder: UntypedFormBuilder, private userService: UserServiceService, private router: Router) {
  }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      title: new UntypedFormControl("", Validators.required),
      firstname: new UntypedFormControl("", Validators.required),
      lastname: new UntypedFormControl("", Validators.required),
      company: new UntypedFormControl("", Validators.required),
      street: new UntypedFormControl("", Validators.required),
      houseNumber: new UntypedFormControl("", Validators.required),
        zip: new UntypedFormControl("", Validators.compose([
            Validators.required
        ])),
      town: new UntypedFormControl("", Validators.required),
      mail: new UntypedFormControl("", Validators.required),
      billingAddress: this.formBuilder.group({
        recipient: new UntypedFormControl(""),
        company: new UntypedFormControl("", Validators.required),
        street: new UntypedFormControl("", Validators.required),
        town: new UntypedFormControl("", Validators.required),
          zip: new UntypedFormControl("", Validators.compose([
              Validators.required
          ]))
      }),
      password: new UntypedFormControl(null, Validators.compose([
        Validators.required,
        CustomValidators.patternValidator(/^(?=.*[0-9])/g,{hasNumber:true}),
        CustomValidators.patternValidator(/^(?=.*[a-z])/g,{hasSmallLetter:true}),
        CustomValidators.patternValidator(/^(?=.*[A-Z])/g,{hasBigLetter:true}),
        CustomValidators.patternValidator(/^(?=.*[_\-!?.@#$%^&*])/g,{hasSpecialCharacter:true}),
        Validators.minLength(8)
      ])),
      passwordConfirm: new UntypedFormControl(null, Validators.required)
    }, {validators: [CustomValidators.passwordMatchValidator]});
  }

  doRegister() {
    this.toNextPage = true;
    if (this.userForm.valid) {
      this.userService.save(this.userForm.value).subscribe(res => {
          this.router.navigate(['/register/success']);
        },
        error => {
          this.errorMessage = ErrorMessages.USER_EXIST;
        });
    } else
      console.log("Nutzer form ist nicht gültig!")
  }

  updateBillingAddress(){
    this.showBilling = !this.showBilling
    if(this.showBilling){
      this.userForm.get('billingAddress.recipient').setValue(this.userForm.get('firstname').value + " " + this.userForm.get('lastname').value);
      this.userForm.get('billingAddress.company').setValue(this.userForm.get('company').value);
      this.userForm.get('billingAddress.street').setValue(this.userForm.get('street').value + " " + this.userForm.get('houseNumber').value);
      this.userForm.get('billingAddress.town').setValue(this.userForm.get('town').value);
      this.userForm.get('billingAddress.zip').setValue(this.userForm.get('zip').value);
    }
    else{
      this.userForm.get('billingAddress.recipient').setValue("");
      this.userForm.get('billingAddress.company').setValue("");
      this.userForm.get('billingAddress.street').setValue("");
      this.userForm.get('billingAddress.town').setValue("");
      this.userForm.get('billingAddress.zip').setValue("");
    }
  }

  hasError(control: AbstractControl): boolean {
    return (control.invalid && (control.touched || this.toNextPage));
  }
}
